/**
 * Share one in-flight call between concurrent callers.
 *
 * For reads several unrelated surfaces ask for at the same moment: the first
 * call goes out, everyone who asks while it is open gets that same promise, and
 * the slot frees as soon as it settles. Only the in-flight window is shared,
 * never a resolved value, so the next caller after it settles still gets a
 * fresh read. A rejection frees the slot too, so a failure never pins it.
 */
export function shareInFlight<T>(call: () => Promise<T>): () => Promise<T> {
  let inFlight: Promise<T> | null = null;

  return () => {
    if (inFlight) return inFlight;
    inFlight = call().finally(() => {
      inFlight = null;
    });
    return inFlight;
  };
}
